import { useGrowWithFaireDetails } from "@faire/deprecated-retailer-visitor-shared/features/GrowWithFaire/useGrowWithFaireDetails";
import { useShouldAdvertiseHolidaySpendChallenge } from "@faire/deprecated-retailer-visitor-shared/features/GrowWithFaire/useShouldAdvertiseHolidaySpendChallenge";
import { useMilestone } from "@faire/marketplace-lib/stores/useMilestone";
import { GROW_WITH_FAIRE_CURRENT_TIP_SEEN } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/GROW_WITH_FAIRE_CURRENT_TIP_SEEN";
import { path as c1CategoryPath } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import { route as fairePayRoute } from "@faire/web-api--source/routes/www/faire-pay";
import { route as nowOnFaireRoute } from "@faire/web-api--source/routes/www/my-brands/now-on-faire";
import { route as findNowOnFaireBrandsRoute } from "@faire/web-api--source/routes/www/my-brands/now-on-faire/find-brands";
import { route as netTermsRoute } from "@faire/web-api--source/routes/www/net-terms";
import { route as netTermsOpenWithFaireApplicationRoute } from "@faire/web-api--source/routes/www/net-terms/owf-application";
import { route as pointOfSaleRoute } from "@faire/web-api--source/routes/www/point-of-sale";
import { route as pointOfSaleOnboardingRoute } from "@faire/web-api--source/routes/www/point-of-sale/onboarding";
import { route as pointOfSaleOrderManagerRoute } from "@faire/web-api--source/routes/www/point-of-sale/order-manager/orderToken";
import { route as homeRoute } from "@faire/web-api--source/routes/www/root";
import { path as c1SuppliersPath } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId";
import { route as supportSelfServeRoute } from "@faire/web-api--source/routes/www/support/self-serve";
import { route as insiderInfoRoute } from "@faire/web-api--source/routes/www/user/insider/info";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { useLocation } from "react-router-dom";

const BLOCKED_PATHS = [
  fairePayRoute,
  findNowOnFaireBrandsRoute,
  homeRoute,
  insiderInfoRoute,
  netTermsRoute,
  netTermsOpenWithFaireApplicationRoute,
  nowOnFaireRoute,
  pointOfSaleRoute,
  pointOfSaleOnboardingRoute,
  pointOfSaleOrderManagerRoute,
  supportSelfServeRoute,
  c1CategoryPath("Insider"),
  c1CategoryPath("Bestsellers"),
  c1SuppliersPath("All Brands"),
];

export const useGrowWithFaireNudge = () => {
  const { pathname } = useLocation();
  const { isOfferActive } = useShouldAdvertiseHolidaySpendChallenge();
  const { isEnrolled } = useGrowWithFaireDetails();
  const { isTabletAndAbove } = useViewport();

  const { hasOccurred: hasSeenNudge, setHasOccurred: setHasSeenNudge } =
    useMilestone(GROW_WITH_FAIRE_CURRENT_TIP_SEEN);

  const isInBlockedPath = BLOCKED_PATHS.some(
    (route) => !!pathMatchesRoute(pathname, route)
  );

  const isNudgeShown =
    isOfferActive &&
    isEnrolled &&
    !hasSeenNudge &&
    !isInBlockedPath &&
    isTabletAndAbove;

  return {
    isNudgeShown,
    dismissNudge: setHasSeenNudge,
  };
};
